var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRadar = function SvgRadar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 4.75a7.25 7.25 0 1 0 5.6 2.645l-.05.054-1.728 1.73a4.75 4.75 0 1 1-1.07-1.051l1.738-1.74.047-.043A7.22 7.22 0 0 0 12 4.75m1.668 4.46a3.25 3.25 0 1 0 1.075 1.046L12.53 12.47a.75.75 0 1 1-1.06-1.061zM3.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0",
    clipRule: "evenodd"
  })));
};
export default SvgRadar;